<template>
  <div class="dashboard">
    <div class="dash-list" v-for="(value, name, index) in dashboardData" :key="index">
      <span class="key">{{value.label}}</span>
      <span class="value">{{value.value}}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Dashboard',
    props: {
      dashboardData: {
        type: Object,
        default () {
          return {}
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  @import "../../index.less";
  .dashboard{
    display: flex;
    padding: 20px;
    margin: 10px;
    border: solid 1px @border-color;
    border-radius: 3px;
    .dash-list{
      flex: 1;
      border-right: dashed 1px @border-color;
      text-align: center;
      &:last-child{
        border: none;
      }
      .key{
        font-size: 14px;
        margin: 0 5px;
      }
      .value{
        font-size: 16px;
        color: @org-color;
        font-weight: bolder;
        margin-right: 5px;
      }
    }
  }
</style>
